import { InventoryLot } from "@/models/InventoryLot";
import { SellContract } from "@/models/SellContract";

export interface CommodityInventorySummary {
  commodity_id: string;
  commodity_color: string;
  commodity_label: string;

  il_length: number;
  sc_length: number;

  il_totals: IlTotal[];
  sc_totals: ScTotal[];
  lt_totals: LtTotal[];
  inventory_lots: InventoryLot[];
  sell_contracts: SellContract[];
}

interface ScTotal {
  lot_unit_id: string;
  lot_unit_label: string;
  end_quantity: number;
}

interface IlTotal {
  lot_unit_id: string;
  lot_unit_label: string;
  start_quantity: number;
}

interface LtTotal {
  lot_unit_id: string;
  lot_unit_label: string;
  total_quantity: number;
}

export function buildNewCommodityInventorySummary(): CommodityInventorySummary {
  return {
    commodity_id: "",
    commodity_color: "",
    commodity_label: "",
    il_length: 0,
    sc_length: 0,
    il_totals: [],
    sc_totals: [],
    lt_totals: [],
    inventory_lots: [],
    sell_contracts: [],
  };
}
